import { MessagesData } from 'interfaces/messagesData';
import React, { useContext } from 'react';
import Chart from 'react-apexcharts';
import ApexCharts from 'apexcharts';
import ptBr from 'apexcharts/dist/locales/pt-br.json';
import en from 'apexcharts/dist/locales/en.json';
import la from 'apexcharts/dist/locales/es.json';
import { LanguageContext } from 'contexts/LanguageContext';

interface Props {
  messagesData: MessagesData;
}

export function TotalMessagesBarChart({ messagesData }: Props) {
  const { dictionary } = useContext(LanguageContext);

  const getOptions = (): ApexCharts.ApexOptions => {
    if (!messagesData) {
      return {};
    }

    const xaxis = [];

    for (const year of Object.keys(messagesData)) {
      for (const month of Object.keys(messagesData[year])) {
        const label = formatDateForLabel(month, year);
        xaxis.push(label);
      }
    }

    const locale = dictionary.locale;
    const title = dictionary.chart_messages_total_title;

    return {
      title: { text: title },
      chart: {
        id: 'total-messages',
        background: '#fff',
        defaultLocale: locale,
        locales: [ptBr, en, la],
        parentHeightOffset: 0,
      },
      xaxis: {
        categories: xaxis,
      },
      plotOptions: {
        bar: {
          dataLabels: {
            position: 'top',
            orientation: 'vertical',
          },
        },
      },
      dataLabels: {
        style: {
          fontSize: '10px',
          colors: ['#373D3F'],
        },
      },
      grid: {
        padding: { bottom: -10, top: -10 },
      },
      yaxis: {
        labels: {
          formatter: (value: number) => {
            let newValue;
            if (value) {
              newValue = value.toLocaleString();
            }
            return newValue ?? String(value);
          },
          offsetX: -15,
        },
      },
    };
  };

  const formatDateForLabel = (month: string, year: string) => {
    let formattedMonth = month;
    if (Number(month) < 10) {
      formattedMonth = '0' + month;
    }

    const formattedYear = year.slice(-2);

    return `${formattedMonth}/${formattedYear}`;
  };

  const getSeries = () => {
    if (!messagesData) {
      return [];
    }

    const series = [];

    for (const year of Object.keys(messagesData)) {
      for (const month of Object.keys(messagesData[year])) {
        const totalMesssages =
          messagesData[year][month].received + messagesData[year][month].sent;
        series.push(totalMesssages);
      }
    }

    const messagesName = dictionary.chart_messages_total;

    return [{ name: messagesName, data: series }];
  };

  return (
    <div className="chartWrapper">
      <Chart
        options={getOptions()}
        series={getSeries()}
        type="bar"
        width={'100%'}
        height={'100%'}
      />
    </div>
  );
}
